import { NgModule } from '@angular/core';
import { defineCustomElements } from '@mri/elements-common/loader';
import { MriAccordion, MriAccordionSection, MriButton, MriCounter, MriDrawer, MriFlyout, MriHider, MriHotkey, MriIcon, MriIconButton, MriNavigationBar, MriNavigationBarWrapper, MriNavigationButton, MriNavigationButtonIcon, MriNavigationButtonMenu, MriNavigationMenuGroup, MriNavigationMenuItem, MriOverlay, MriSpinner, MriSplitButton, MriSuccessStamp, MriSwitch } from './directives/proxies';
import { BooleanValueAccessor } from './directives/boolean-value-accessor';
import * as i0 from "@angular/core";
defineCustomElements(window);
const PROXIES = [MriAccordion, MriAccordionSection, MriButton, MriCounter, MriDrawer, MriFlyout, MriHider, MriHotkey, MriIcon, MriIconButton, MriNavigationBar, MriNavigationBarWrapper, MriNavigationButton, MriNavigationButtonIcon, MriNavigationButtonMenu, MriNavigationMenuGroup, MriNavigationMenuItem, MriOverlay, MriSpinner, MriSplitButton, MriSuccessStamp, MriSwitch];
const VALUE_ACCESSORS = [BooleanValueAccessor];
const DECLARATIONS = [...PROXIES, ...VALUE_ACCESSORS];
export let ElementsCommonModule = /*#__PURE__*/(() => {
  class ElementsCommonModule {}
  /** @nocollapse */
  /** @nocollapse */
  /** @nocollapse */ElementsCommonModule.ɵfac = function ElementsCommonModule_Factory(t) {
    return new (t || ElementsCommonModule)();
  };
  ElementsCommonModule.ɵmod = /** @pureOrBreakMyCode */i0.ɵɵdefineNgModule({
    type: ElementsCommonModule
  });
  ElementsCommonModule.ɵinj = /** @pureOrBreakMyCode */i0.ɵɵdefineInjector({});
  return ElementsCommonModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ElementsCommonModule, {
    declarations: [MriAccordion, MriAccordionSection, MriButton, MriCounter, MriDrawer, MriFlyout, MriHider, MriHotkey, MriIcon, MriIconButton, MriNavigationBar, MriNavigationBarWrapper, MriNavigationButton, MriNavigationButtonIcon, MriNavigationButtonMenu, MriNavigationMenuGroup, MriNavigationMenuItem, MriOverlay, MriSpinner, MriSplitButton, MriSuccessStamp, MriSwitch, BooleanValueAccessor],
    exports: [MriAccordion, MriAccordionSection, MriButton, MriCounter, MriDrawer, MriFlyout, MriHider, MriHotkey, MriIcon, MriIconButton, MriNavigationBar, MriNavigationBarWrapper, MriNavigationButton, MriNavigationButtonIcon, MriNavigationButtonMenu, MriNavigationMenuGroup, MriNavigationMenuItem, MriOverlay, MriSpinner, MriSplitButton, MriSuccessStamp, MriSwitch, BooleanValueAccessor]
  });
})();
